import { Link } from "react-router-dom";
import { ImageCard } from "../components/Cards.js";
const Collection = () => {
  const NFTList = [
    ["Japan", "down-right"],
    ["France", "down-left"],
    ["Egypt", "up-right"],
    ["Antarctica", "up-left"],
  ];
  const ImageCardList = NFTList.map((NFT, index) => {
    return (
      <div className={"leo-" + (index + 1)} key={index}>
        <Link to="/collections">
          <ImageCard index={index} file={NFT[0]} effect={NFT[1]} />
        </Link>
      </div>
    );
  });
  return (
    <div
      className="container"
      data-aos="fade-up"
      data-aos-duration="1200"
      id="collection"
    >
      <div className="row">
        <div className="col-12 pre">
          <h3>The Collection</h3>
          <h2>A roaring NFT collection</h2>
        </div>
        <div className="col-12 col-lg-10 mx-auto">
          <div className="pre-parallax">{ImageCardList}</div>
        </div>
      </div>
    </div>
  );
};

export default Collection;
